import { Button, Col, Row, Select } from "antd";
import { ReactNode } from "react";
import { Modal } from "react-bootstrap";
import { AnyObject } from "antd/es/_util/type";

const ModalTextForm = ({ title, show, hideFooter, size, dialogClassName, handleClose, handleSave, children, propsArray }: { title: string, show: boolean, hideFooter?: boolean, size?: "xl" | "lg" | "sm" | undefined, dialogClassName?: string, handleClose?: VoidFunction, handleSave?: VoidFunction, children: ReactNode, propsArray?: Array<AnyObject> }) => {
    return (
        <Modal show={show} onHide={handleClose} size={size ? size : "lg"} dialogClassName={dialogClassName ? dialogClassName : undefined}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    {
                        propsArray?.map((item) => (
                            <Col span="24" className="form-group" key={item?.label}>
                                <label>{item?.label} <span className="text-red">*</span></label>
                                <Select
                                    style={{ width: '100%' }}
                                    showSearch
                                    placeholder="--Tất cả--"
                                    filterOption={function (search, item: any) {
                                        return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
                                    }}
                                    options={item?.options}
                                    value={item?.value}
                                    onChange={(e) => item?.handleChange(e)}
                                />
                            </Col>
                        ))
                    }
                </Row>
                {children}
            </Modal.Body>
            {
                !hideFooter &&
                    <Modal.Footer>
                        <Button type="primary" danger onClick={handleClose}>Đóng</Button>
                        <Button type="primary" onClick={handleSave}>Xác nhận</Button>
                    </Modal.Footer>
            }
        </Modal>
    )
};

export default ModalTextForm;